/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import ClipboardJS from "clipboard";

const root = (typeof window !== "undefined") ? window : globalThis;

root.shareData = {};

root.shareSetLink = function(url, text, hashtags) {
  root.shareData.url = url;
  if (text) { root.shareData.text = text; }
  if (hashtags) { return root.shareData.hashtags = hashtags; }
};

root.shareWith = function(what) {
  const s = root.shareData;
  if (what === 'facebook') {
    window.open('https://www.facebook.com/dialog/share?' + $.param({app_id: root.FACEBOOK_APP_ID, href: s.url, display: 'page', redirect_uri: 'https://www.flashvote.com'}));
  } else if (what === 'linkedin') {
    window.open('https://linkedin.com/sharing/share-offsite?' + $.param({url: s.url}));
  } else if (what === 'twitter') {
    window.open('https://twitter.com/share?' + $.param({url: s.url, text: s.text, hashtags: s.hashtags}));
  } else if (what === 'native') {
    navigator.share(s);
  }
  return false;
};

root.showCopied = function(el) {
  const $el = $(el);
  $el.tooltipster({content:'Copied to clipboard!'}).tooltipster('show');
  return window.setTimeout((() => $el.tooltipster('hide')), 1000);
};

root.showNotCopied = function(el) {
  const $el = $(el);
  $el.tooltipster({content:"Press Ctrl+C or ⌘-C to copy"}).tooltipster('show');
  return window.setTimeout((() => $el.tooltipster('hide')), 2000);
};

root.initShareLinks = function() {
  if ($('.clipboard-copy').length) {
    const clipboard = new ClipboardJS('.clipboard-copy');
    clipboard.on('success', function(e) {
      e.clearSelection();
      showCopied(e.trigger);
    });

    clipboard.on('error', function(e) {
      showNotCopied(e.trigger);
    });
  }

  return $('.social-share-links').each(function() {
    // Use .find() to locate descendant elements instead of the deprecated
    // and incorrect jQuery .select() plugin-style call.
    $(this).find('.share-link').each(function(index) {
      return initShareLink(this);
    });
    if ($(this).find('.native').length && navigator.share && root.shareData) {
      return $(this).addClass('has-native-share-support');
    }
  });
};

var initShareLink = function(shareLink) {
  const $shareLink = $(shareLink);
  const $link = $shareLink.find('.link');
  const content = $shareLink.parent().find('.share-link-content').remove();
  $link.tooltipster({
    contentAsHTML: true,
    content,
    interactive: true,
    interactiveTolerance: 1000
  });
};

/*$(() => initShareLinks());*/

function initShareLinksOnLoad() {
  if ($('.clipboard-copy').length) {
    initShareLinks();
  }
}

$(initShareLinksOnLoad);
document.addEventListener('turbo:load', initShareLinksOnLoad);
